import { Stack, Typography } from "@mui/material"
import { ConfirmModal } from "../../../../../../shared/components/dialogs/ConfirmModal"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { StandardAlertInfo } from "../../../../../../shared/components/alert/StandardAlertInfo"
import { ManageBookingsAction, ManageBookingsExcludedOrder } from "../manageBookingsTypes"

type Props = Readonly<{
    open: boolean
    onClose: () => void
    onConfirm: () => void
    isLoading: boolean
    action: ManageBookingsAction
    affectedOrders: number
    excludedOrders: ManageBookingsExcludedOrder[]
    userName: string
    userEmail: string
    newOwnerName?: string
    newOwnerEmail?: string
}>

export function ManageBookingsConfirmDialog({
    open,
    onClose,
    onConfirm,
    isLoading,
    action,
    affectedOrders,
    excludedOrders,
    userName,
    userEmail,
    newOwnerName,
    newOwnerEmail,
}: Props) {
    const { l10n } = useAppLocalization()

    const title =
        action === ManageBookingsAction.CHANGE_ORGANIZER
            ? l10n.getString("service-center-admin-organization-manage-bookings-confirm-modal-move-title")
            : l10n.getString("service-center-admin-organization-manage-bookings-confirm-modal-delete-title")

    const message =
        action === ManageBookingsAction.CHANGE_ORGANIZER
            ? l10n.getString("service-center-admin-organization-manage-bookings-confirm-modal-move-message", {
                  count: affectedOrders,
                  userName,
                  userEmail,
                  newOwnerName: newOwnerName ?? "",
                  newOwnerEmail: newOwnerEmail ?? "",
              })
            : l10n.getString("service-center-admin-organization-manage-bookings-confirm-modal-delete-message", {
                  count: affectedOrders,
                  userName,
                  userEmail,
              })

    const buttonLabel = l10n.getString(
        action === ManageBookingsAction.CHANGE_ORGANIZER
            ? "service-center-admin-organization-manage-bookings-confirm-modal-move-button"
            : "service-center-admin-organization-manage-bookings-confirm-modal-delete-button",
    )

    return (
        <ConfirmModal
            open={open}
            onClose={onClose}
            title={title}
            handleClick={onConfirm}
            buttonLabelSubmit={buttonLabel}
            buttonSubmitLoading={isLoading}
            buttonColorSubmit="black"
            autoCloseAfterSubmit={false}
        >
            <Typography variant="body1" textAlign="center">{message}</Typography>
            {excludedOrders.length > 0 && (
                <Stack gap="0.5rem" width="100%" alignItems="center">
                    {excludedOrders.map((item, i) => (
                        <StandardAlertInfo
                            key={i}
                            title={l10n.getString(
                                "service-center-admin-organization-manage-bookings-confirm-modal-excluded-orders",
                                { count: item.count, reason: item.reason },
                            )}
                        />
                    ))}
                </Stack>
            )}
        </ConfirmModal>
    )
}
